import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {labels} from '../../../../../util/utils';

import OutputText from '@ey/canvascoreservices/OutputText';
import {IconoirProhibition} from '@ey-xd/motif-icon';

import Modal from '../../../../CoreWrappers/Modal';
import IconMessage from '../../../../CoreWrappers/IconMessage';
import ExportMessageLog from './ExportMessageLog';
import MessageLogFilter from './Filter';

import StyledMessageLog from './StyledMessageLog';
import {getMessageLog, clearMessageLogFilters} from '../../../../../actions/ContactDB';
import {messageLogIcon} from '../../../../../util/svgIcons';
import Activity from './Activity';
import LoadingWrapper from '../../../../CoreWrappers/LoadingWrapper';
import StyledGrid from './StyledGrid';
import ToolbarButton from '../ToolbarButton';
import HrAlt from '../../../../Common/Hr/HrAlt';

const MessageLog = () => {
	const messageLog = useSelector(({messageLog}) => messageLog);
	const projectId = useSelector(({project}) => project?.projectId);

	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);

	const dispatch = useDispatch();

	const data = messageLog.displayedMessages;

	useEffect(() => {
		if (data === null && open) {
			setLoading(true);
			dispatch(getMessageLog(projectId))
				.then(() => setLoading(false))
				.catch(() => setLoading(false));
		}
		if (data !== null && open === false) {
			dispatch(clearMessageLogFilters());
		}
	}, [open]);

	const renderEmpty = () => {
		const emptyListLabel = _.isEmpty(messageLog.filters) ? labels.messageLogEmptyMessage : labels.noResultsFound;

		const props = {
			icon: IconoirProhibition,
			className: 'list-with-scroll-empty',
			subTitle: emptyListLabel,
			title: ''
		};

		return <IconMessage {...props} />;
	};

	const renderAccordion = () => {
		const props = {
			messagesList: data,
			hideMessageLog: () => {
				setOpen(false);
			}
		};
		return <Activity {...props} />;
	};

	const renderTrigger = () => {
		const handlerOnOpenClick = () => {
			setOpen(true);
		};

		const props = {
			label: labels.toolbarMessageLog,
			svg: messageLogIcon,
			onClick: handlerOnOpenClick
		};

		return <ToolbarButton {...props} />;
	};

	const renderInstructionText = () => {
		const desc = labels.messageLogInstruction;
		return (
			<div className="instruction-text">
				<OutputText light>{desc}</OutputText>
			</div>
		);
	};

	const renderModal = () => {
		const handlerOnHide = () => {
			setOpen(false);
		};

		const props = {
			labels: {
				modalConfirmBtnLabel: labels.closeTitleModal,
				modalCloseBtnTitletip: labels.closeTitleModal,
				modalMiddleBtnLabel: ''
			},
			show: open,
			headerText: labels.messageLogTitle,
			hideCancelButton: true,
			modalsize: 'large',
			onOkClick: handlerOnHide,
			onClose: handlerOnHide
		};

		return (
			open && (
				<Modal {...props}>
					<LoadingWrapper isLoading={loading}>
						<StyledMessageLog className={'customScrollbar'}>
							<StyledGrid>
								{renderInstructionText()}
								<HrAlt $color="--neutrals-100" />
								<div className="buttons-container">
									<div className="filter-container">
										<MessageLogFilter />
									</div>
									<ExportMessageLog />
								</div>
								{data?.length === 0 && renderEmpty()}
								{data !== null && renderAccordion()}
							</StyledGrid>
						</StyledMessageLog>
					</LoadingWrapper>
				</Modal>
			)
		);
	};

	return (
		<>
			{renderTrigger()}
			{renderModal()}
		</>
	);
};

export default MessageLog;
